import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from '@emotion/styled/macro'
import { Link } from 'react-router-dom'
import mq from 'mediaQuery'
import PencilIcon from '../Icons/Pencil'
import RegistrarIcon from '../Icons/Registrar'
import useDarkMode from 'use-dark-mode'
import AddFavourite from 'components/AddFavorite'

const TabContainer = styled('div')`
  display: flex;
  justify-content: flex-end;
`

const TabLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ active }) => (active ? '#5E17FE' : '#EEEEEE')};
  color: ${({ active }) => (active ? 'white' : '#757575')};
  transition: background 0.1s ease-out, transform 0.3s ease-out;
  padding: 8px 12px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: 0.15px;
  text-transform: capitalize;

  &:hover,
  &:visited {
    color: ${({ active }) => (active ? 'white' : '#757575')};
  }

  ${mq.small`
    font-size: 20px;
    padding: 10px 30px;
  `}

  svg {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
`

function getDetailsActive(domain, pathname, tab) {
  const { name } = domain
  if (domain.parent !== process.env.REACT_APP_REGISTRAR_TLD) {
    return (
      pathname !== `/name/${name}/register` &&
      pathname !== `/name/${name}/subdomains`
    )
  } else {
    return (
      (tab === 'details' || pathname === `/name/${name}/details`) &&
      (pathname !== `/name/${name}/register` &&
        pathname !== `/name/${name}/subdomains`)
    )
  }
}

const Tabs = ({
  domain,
  pathname,
  parent,
  tab,
  account,
  registerTabText,
  detailsTabText
}) => {
  const { t } = useTranslation()
  const { name, state } = domain
  const darkMode = useDarkMode(true)
  const isDark = darkMode.value

  const favorites = localStorage.getItem(`favorite_ans_${account}`)
  let isFavorite
  if (!favorites) isFavorite = false
  else {
    const arr = favorites.split(',')
    const isExist = arr.filter(element => element === domain?.name)
    isFavorite = isExist.length > 0
  }

  return (
    (state !== 'Auction' || state !== 'Reveal') && (
      <TabContainer>
        <AddFavourite
          domain={domain}
          account={account}
          isFavorite={isFavorite}
          style={{ marginRight: 20 }}
        />
        {parent === process.env.REACT_APP_REGISTRAR_TLD && (
          <TabLink
            active={
              (tab === 'register' || pathname === `/name/${name}/register`) &&
              (pathname !== `/name/${name}/details` &&
                pathname !== `/name/${name}/subdomains`)
            }
            to={`/name/${name}/register`}
          >
            <RegistrarIcon active={getDetailsActive(domain, pathname, tab)} />
            {registerTabText}
          </TabLink>
        )}

        <TabLink
          active={getDetailsActive(domain, pathname, tab)}
          to={`/name/${name}/details`}
        >
          <PencilIcon active={getDetailsActive(domain, pathname, tab)} />
          {detailsTabText}
        </TabLink>
      </TabContainer>
    )
  )
}
export default Tabs
